import { render } from "./LoadingAnimation.vue?vue&type=template&id=a332375a&scoped=true"
import script from "./LoadingAnimation.vue?vue&type=script&lang=js"
export * from "./LoadingAnimation.vue?vue&type=script&lang=js"

import "./LoadingAnimation.vue?vue&type=style&index=0&id=a332375a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a332375a"

export default script